import React from "react";
import { Box, Skeleton } from "@mui/material";
import { CREATE_CARD_GRID_SX } from "../CreateNotice/createStyles";

/** Placeholder cards shaped like certificate cards (Templates, Awards), shown while a list loads. */
const CertificateCardsSkeleton: React.FC<{ label: string }> = ({ label }) => (
  <Box role="status" aria-label={label} sx={CREATE_CARD_GRID_SX}>
    {[0, 1, 2].map((card) => (
      <Box key={card}>
        <Skeleton
          variant="rounded"
          sx={{ width: "100%", height: "auto", aspectRatio: "1123 / 794" }}
        />
        <Skeleton variant="text" width="60%" height={24} />
        <Skeleton variant="text" width="40%" height={20} />
      </Box>
    ))}
  </Box>
);

export default CertificateCardsSkeleton;
